module.exports = __webpack_public_path__ + "img/DSC01581.7dc29c52.jpg";